"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svg_1 = require("@obvio/svg");
const components_1 = require("./Layout/components");
function Layout({ left, right, logo: Logo = svg_1.SvgLogo, }) {
    return ((0, jsx_runtime_1.jsxs)(components_1.Wrap, Object.assign({ templateColumns: "50% 50%" }, { children: [(0, jsx_runtime_1.jsx)(components_1.LeftColumn, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.LogoWrap, { children: (0, jsx_runtime_1.jsx)(Logo, {}) }), left] }) }), (0, jsx_runtime_1.jsx)(components_1.RightColumn, { children: (0, jsx_runtime_1.jsx)("div", { children: right }) })] })));
}
exports.Layout = Layout;
